import { useState, useLayoutEffect, useEffect } from "react";
var BORDER_WIDTH = 2;
export function useTableWidth(ref) {
    var _a = useState(), innerWidth = _a[0], setInnerWidth = _a[1];
    var updateWidth = function () { var _a; return setInnerWidth((_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.offsetWidth); };
    useLayoutEffect(function () {
        window.addEventListener("resize", updateTableWidthOnResize);
        updateTableWidthOnResize();
        return function () { return window.removeEventListener("resize", updateTableWidthOnResize); };
    }, [ref]);
    var updateTableWidthOnResize = function () {
        var parentComponent = document.querySelector(".table-parent");
        var outerWidth = parentComponent === null || parentComponent === void 0 ? void 0 : parentComponent.getBoundingClientRect().width;
        if ((innerWidth && outerWidth && outerWidth > innerWidth) ||
            innerWidth === undefined) {
            outerWidth && setInnerWidth(outerWidth - BORDER_WIDTH);
        }
    };
    var updateTableWidth = function () {
        var handler = setTimeout(function () {
            var drawerComponent = document.querySelectorAll(".list__drawer--contents");
            var drawerWidth = 0;
            drawerComponent.forEach(function (drawer, i) {
                var rowDrawerWidth = drawer.getBoundingClientRect().width;
                if (rowDrawerWidth >= drawerWidth) {
                    drawerWidth = rowDrawerWidth;
                }
            });
            setInnerWidth(drawerWidth === 0 ? undefined : drawerWidth);
        }, 1);
        return function () { return clearTimeout(handler); };
    };
    useEffect(function () {
        if (ref)
            updateWidth();
    }, [ref]);
    return { width: innerWidth, updateTableWidth: updateTableWidth };
}
